import { render, staticRenderFns } from "./message-details-dialog.vue?vue&type=template&id=625f732e&scoped=true&"
import script from "./message-details-dialog.vue?vue&type=script&lang=js&"
export * from "./message-details-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625f732e",
  null
  
)

export default component.exports